import { Eye, EyeOff } from 'lucide-react';

import { CopyButton } from '@/components/copy-button';
import { Button } from '@/components/ui/button';

import { useApiKeyRevealStore } from '@/store/api-key-reveal.store';

export const ApiKeyValueCell = ({ id, apiKey }: { id: number; apiKey: string }) => {
  const isRevealed = useApiKeyRevealStore(state => state.revealedKeys.has(id));
  return (
    <span className="font-mono text-sm text-foreground">
      {isRevealed ? apiKey : '•'.repeat(32)}
    </span>
  );
};

export const ApiKeyActionsCell = ({ id, apiKey }: { id: number; apiKey: string }) => {
  const isRevealed = useApiKeyRevealStore(state => state.revealedKeys.has(id));
  const toggleReveal = useApiKeyRevealStore(state => state.toggleReveal);

  return (
    <div className="flex items-center gap-1">
      <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => toggleReveal(id)}>
        {isRevealed ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
      </Button>
      <CopyButton
        value={apiKey}
        tooltip="Copy API key"
        className="h-7 w-7"
        message="API key copied to clipboard"
      />
    </div>
  );
};
